<template>
    <div id="employee_report_modal" class="modal custom-modal fade" role="dialog">
        <div class="modal-dialog modal-fullscreen" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title ms-5">Employee Report ({{ userName }})</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="content container-fluid">
                        <div class="row filter-row">
                            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
                                <div class="input-block mb-3 form-focus">
                                    <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                                        style="z-index: 100; font-size: 12px;">From</label>
                                    <div class="cal-icon">
                                        <date-picker v-model="startDate" class="form-control floating datetimepicker"
                                            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick"  />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
                                <div class="input-block mb-3 form-focus">
                                    <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                                        style="z-index: 100; font-size: 12px;">To</label>
                                    <div class="cal-icon">
                                        <date-picker v-model="endDate" placeholder="To" class="form-control floating datetimepicker"
                                            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick"  />
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
                                <a href="javascript:;" class="btn btn-success w-100" @click="onSearchClick"> Search </a>
                            </div> -->
                            <v-divider opacity="0.5"></v-divider>
                        </div>
                        <div>
                            <v-col cols="12" class="pb-0 d-flex justify-content-end">
                                <div>
                                    <div class="btn btn-outline-success ms-3" @click="downloadUserReport()">
                                        <span v-if="!singleDownloadLoad">Download Simple Report</span>
                                        <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                            <div class="spinner-border spinner-border-sm" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="btn btn-outline-success ms-3" @click="downloadFullReport()">
                                        <span v-if="!fullDownloadLoad">Download Full Report</span>
                                        <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                            <div class="spinner-border spinner-border-sm" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </div>
                        <div v-if="loading" class="d-flex justify-content-center align-items-center my-5" style="min-height: 200px;">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <h4 class="pb-3">Summary</h4>
                            <v-row>
                            <v-col cols="12" sm="6">
                                <v-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">Type</th>
                                                <th class="text-left">24H</th>
                                                <th class="text-left">Schedule</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Time on site including break taken</td>
                                                <td>{{ timeOnSite }}</td>
                                                <td>{{ totalTimeOnSiteIncludingBreakSchedule }}</td>
                                            </tr>
                                            <tr>
                                                <td>Break taken</td>
                                                <td>{{ totalBreakTime }}</td>
                                                <td>{{ totalBreakTime }}</td>
                                            </tr>
                                            <tr>
                                                <td>Allowed paid break</td>
                                                <td>{{ allowedBreak }}<span v-if="totalExtraBreak > 0"> (+{{ totalExtraBreak }} mins)</span></td>
                                                <td>{{ totalScheduledBreak }}</td>
                                            </tr>
                                            <tr>
                                                <td>Leave days (Hours worked)</td>
                                                <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                                <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                            </tr>
                                            <tr>
                                                <td>Time on site after break deduction</td>
                                                <td>{{ totalTimeOnSiteAfterBreakDeduction }}</td>
                                                <td>{{ totalTimeOnSiteAfterBreakSchedule }}</td>
                                            </tr>
                                            <tr>
                                                <td>Expected time on site</td>
                                                <td>{{ totalExpectedTimeOnSite }}</td>
                                                <td>{{ totalExpectedTimeOnSite }}</td>
                                            </tr>
                                            <tr>
                                                <td>Additional shift time / Banked time</td>
                                                <td>{{ bankedTime }}</td>
                                                <td>{{ bankedTime }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-table>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">Type</th>
                                                <th class="text-left">Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Working days</td>
                                                <td>{{ workingDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Actual days present</td>
                                                <td>{{ presentDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Non working days</td>
                                                <td>{{ nonWorkingDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Absent</td>
                                                <td>{{ absent }}</td>
                                            </tr>
                                            <!-- <tr>
                                                <td>Leave days (Hours worked)</td>
                                                <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                            </tr> -->
                                            <tr>
                                                <td>Unpaid leaves</td>
                                                <td>{{ unPaidLeaves }}</td>
                                            </tr>
                                            <tr>
                                                <td>Sick leave</td>
                                                <td>{{ totalSickLeaveDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Unscheduled work days</td>
                                                <td>{{ unscheduledWorkDays }}</td>
                                            </tr>
                                            <tr>
                                                <td>Manually edited days</td>
                                                <td>{{ manuallyEditedDays }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-table>
                            </v-col>
                        </v-row>
                        <v-divider opacity="0.5"></v-divider>
                        <div v-for="r of report" :key="r.schedule.date" class="report">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="d-flex align-items-center flex-wrap">
                                    <h3 class="my-2 me-3">
                                        {{ dateToMonthName(r['schedule']['date']) }}
                                    </h3>
                                     <v-chip v-if="r['isUserOnLeave']" class="ma-1" color="primary" text-color="white" size="small">
                                         On Leave {{ r['leaveApplication']?.['leave_hour'] ? `(${r['leaveApplication']['leave_hour'].slice(0, 5)})` : '' }}
                                     </v-chip>
                                    <v-chip v-else-if="!r['isPresent'] && r['schedule']?.['is_working'] && r['schedule']?.['user_schedule_shifts']?.length > 0" class="ma-1"
                                        color="red" text-color="white" size="small">Absent
                                    </v-chip>
                                    <v-chip v-if="(!r['schedule']?.['is_working'] || r['schedule']?.['user_schedule_shifts']?.length == 0) && !r['isUnscheduledWork'] && !r['isUserOnLeave']" class="ma-1" color="primary"
                                        text-color="white" size="small">NWD
                                    </v-chip>
                                    <v-chip v-if="r['isUnscheduledWork']" class="ma-1" color="warning"
                                        text-color="white" size="small">Unscheduled
                                    </v-chip>
                                    <v-chip v-if="r['isManuallyEdited']" class="ma-1" color="amber-darken-3"
                                        text-color="white" size="small">Edited
                                    </v-chip>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <div class="btn btn-outline-info" @click="getUserReport($event)">
                                        <i class="fa-solid fa-arrows-rotate me-1" v-if="!isRefreshing"></i>
                                        <span class="spinner-border spinner-border-sm me-1" role="status" v-else></span>
                                        Refresh
                                    </div>
                                    <span class="icon-circle-2 text-nowrap" style="cursor: pointer;" @click="openAddActivityModal(r)">
                                        <i class="fa fa-plus me-1"></i> Add Activity
                                    </span>
                                </div>
                            </div>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Type</th>
                                                    <th class="text-left">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Schedule</td>
                                                    <td>
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <div v-if="r['schedule']?.['user_schedule_shifts']?.length > 0">
                                                                    <div v-for="(shift, index) in r['schedule']['user_schedule_shifts']" :key="index">
                                                                        {{ timeFormat(shift.from_time) }} - {{ timeFormat(shift.to_time) }}
                                                                    </div>
                                                                </div>
                                                                <div v-else>00:00 - 00:00</div>
                                                            </div>
                                                            <span href="javascript:;" @click="editScheduleClicked(r['schedule'])" class="icon-circle">
                                                                <i class="fa-solid fa-pen" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i>
                                                            </span>
                                                        </div>
                                                        <div v-if="r['schedule']?.['updated_by'] || r['schedule']?.['updated_by_user']" class="text-muted mt-1" style="font-size: 0.75rem;">
                                                            <i class="fa-solid fa-pen-to-square me-1 text-warning"></i>
                                                            Updated 
                                                            <span v-if="r['schedule']?.['updated_by_user']">
                                                                by <strong>{{ r['schedule']['updated_by_user']['first_name'] }} {{ r['schedule']['updated_by_user']['last_name'] }}</strong>
                                                            </span>
                                                            <span v-else-if="r['schedule']?.['updated_by']">
                                                                by <strong>User #{{ r['schedule']['updated_by'] }}</strong>
                                                            </span>
                                                            <span v-if="r['schedule']?.['updated_at']">
                                                                at <strong>{{ formatDateTimeStandardWithTime(r['schedule']['updated_at']) }}</strong>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>First entry & last exit</td>
                                                    <td>
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <span>{{ timeFormat(r['firstCheckIn']) }} - {{ timeFormat(r['lastCheckOut']) }}</span>
                                                            <span v-if="r['schedule']['user_attendance']" href="javascript:;" @click="editAttendanceClicked(r['schedule']['user_attendance'])" class="icon-circle">
                                                                <i class="fa-solid fa-pen" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i>
                                                            </span>
                                                        </div>
                                                        <div v-if="r['schedule']?.['user_attendance']?.['is_manually_edited']" class="text-muted mt-1" style="font-size: 0.75rem;">
                                                            <i class="fa-solid fa-pen-to-square me-1 text-warning"></i>
                                                            Updated 
                                                            <span v-if="r['schedule']['user_attendance']['updated_by_user']">
                                                                by <strong>{{ r['schedule']['user_attendance']['updated_by_user']['first_name'] }} {{ r['schedule']['user_attendance']['updated_by_user']['last_name'] }}</strong>
                                                            </span>
                                                            <span v-else-if="r['schedule']['user_attendance']['updated_by']">
                                                                by <strong>{{ r['schedule']['user_attendance']['updated_by'] }}</strong>
                                                            </span>
                                                            <span v-if="r['schedule']['user_attendance']['updated_at']">
                                                                at <strong>{{ formatDateTimeStandardWithTime(r['schedule']['user_attendance']['updated_at']) }}</strong>
                                                            </span>
                                                            <span v-if="r['schedule']['user_attendance']['reason']">
                                                                &bull; <em>{{ r['schedule']['user_attendance']['reason'] }}</em>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Expected time on site</td>
                                                    <td>{{ toTimeString(r['expectedTimeOnSite']) }}</td>
                                                </tr>
                                                 <tr>
                                                     <td>Additional shift time / Banked time</td>
                                                     <td>{{ toTimeString(r['bankedTime']) }}</td>
                                                 </tr>
                                                 <tr v-if="r['isUserOnLeave'] && r['leaveApplication']?.['leave_hour']">
                                                     <td>Leave hours</td>
                                                     <td>{{ r['leaveApplication']['leave_hour'].slice(0, 5) }}</td>
                                                 </tr>
                                            </tbody>
                                        </template>
                                    </v-table>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Type</th>
                                                    <th class="text-left">24H</th>
                                                    <th class="text-left">Schedule</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Time on site including break taken</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['timeOnSiteIncludingBreakInMin']) }}</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['timeOnSiteWithinScheduleInMin']) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Break taken</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['breakTimeInMin']) }}</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['breakTimeInMin']) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Allowed paid break</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['allowedBreak']) }}<span v-if="r['isPresent'] && (r['breakTimeInMin'] > r['allowedBreak'])"> (+{{ Math.round(r['breakTimeInMin'] - r['allowedBreak']) }} mins)</span></td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['scheduledDeduction'] || 0) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Time on site after break deduction</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(Math.max(0, r['timeOnSiteIncludingBreakInMin'] - Math.max(r['breakTimeInMin'], r['allowedBreak']))) }}</td>
                                                    <td>{{ !r['isPresent'] ? '00:00' : toTimeString(Math.max(0, r['timeOnSiteWithinScheduleInMin'] - Math.max(r['breakTimeInMin'], r['allowedBreak']))) }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-table>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="r.activities.length">
                                    <h6 class="pb-3">Activities(24 hours)</h6>
                                    <v-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Time</th>
                                                    <th class="text-left">Type</th>
                                                    <th class="text-left">Location</th>
                                                    <th class="text-left">Edited</th>
                                                    <th class="text-left">Reason</th>
                                                    <th class="text-left">Updated By</th>
                                                    <th class="text-left">Updated At</th>
                                                    <th class="text-left">Activity Time</th>
                                                    <th class="text-left">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(a, idx) in r.activities" :key="a.id">
                                                    <td>{{ formatTo12Hour(a.created_at) }}</td>
                                                    <td>{{ getActivityTypeLabel(a.type) }}</td>
                                                    <td>{{ getLocationName(a.location_id) }}</td>
                                                    <td>{{ a.is_manually_edited ? 'Yes' : 'No' }}</td>
                                                    <td>{{ a.reason ? a.reason : '--' }}</td>
                                                    <td>{{ a.updated_by_user ? (a.updated_by_user.first_name + ' ' + a.updated_by_user.last_name) : (a.updated_by && a.updated_by.first_name ? (a.updated_by.first_name + ' ' + a.updated_by.last_name) : (a.updated_by ? a.updated_by : '--')) }}</td>
                                                    <td>{{ a.is_manually_edited && a.updated_at ? formatDateTimeStandardWithTime(a.updated_at) : '--' }}</td>
                                                    <td v-if="r.activities[idx + 1]">{{ getDiffMinutes(a.created_at, r.activities[idx + 1].created_at) }}</td>
                                                    <td v-else>--</td>
                                                    <td>
                                                        <div class="d-flex gap-2">
                                                            <span class="icon-circle" style="cursor: pointer;" @click="editActivityClicked(a)">
                                                                <i class="fa-solid fa-pen"></i>
                                                            </span>
                                                            <span class="icon-circle" style="cursor: pointer;" @click="deleteActivityClicked(a)">
                                                                <i class="fa-solid fa-trash-can"></i>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-table>
                                </v-col>
                                <v-divider opacity="0.5"></v-divider>
                            </v-row>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <edit-attendance-modal ref="editAttendance" id="edit_attendance_report"></edit-attendance-modal>
    <edit-schedule-modal ref="editSchedule" @editedShift="getUserReport" id="edit_schedule_report"></edit-schedule-modal>
    <edit-activity-modal ref="editActivity" @activityUpdated="getUserReport" id="edit_activity_report"></edit-activity-modal>
    <add-manual-activity-modal ref="addActivity" @activityAdded="getUserReport" id="add_manual_activity_report"></add-manual-activity-modal>

    <!-- Delete Activity Confirmation Modal -->
    <div class="modal fade" id="delete_activity_modal_report" tabindex="-1" aria-labelledby="deleteActivityLabelReport" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deleteActivityLabelReport">Delete Activity</h5>
                    <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Are you sure you want to delete this activity?</p>
                    <div v-if="activityToDelete">
                        <p class="mb-1"><strong>Type:</strong> {{ getActivityTypeLabel(activityToDelete.type) }}</p>
                        <p class="mb-0"><strong>Time:</strong> {{ activityToDelete.created_at }}</p>
                    </div>
                    <p class="text-danger mb-0"><small>This action cannot be undone. If deleted in the wrong order, the report will contain errors.</small></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-outline-danger" @click="onDeleteConfirmed" :disabled="isDeleting">
                        <span v-if="!isDeleting">Delete</span>
                        <div v-else class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { dateRangeStart, dateRangeEnd } from '@/utils/util-var';
import { VUE_APP_API_BASE_URL } from "../../config";
import { formatDDMMYYYY, formatMMNameYYYY, formatDayDateMonthYear, minToTimeString, timeFormat, formatTo12Hour, getActivityTypeLabel, formatDateTimeStandardWithTime } from '@/utils/util-funcitons';
import EditAttendanceModal from "@/components/modal/edit-user-attendance-modal.vue";
import EditScheduleModal from "@/components/modal/edit-schedule-modal.vue";
import EditActivityModal from "@/components/modal/edit-activity-modal.vue";
import AddManualActivityModal from "@/components/modal/add-manual-activity-modal.vue";

export default {
    components: {
        EditAttendanceModal,
        EditScheduleModal,
        EditActivityModal,
        AddManualActivityModal
    },
    data() {
        return {
            userId: null,
            startDate: dateRangeStart,
            endDate: dateRangeEnd,
            dateFormat: 'dd/MM/yyyy',
            userName: '',
            allowedBreak: '00:00',
            totalExtraBreak: 0,
            totalExpectedTimeOnSite: '00:00',
            totalTimeOnSiteAfterBreakDeduction: '00:00',
            totalTimeOnSiteAfterBreakSchedule: '00:00',
            totalTimeOnSiteIncludingBreakSchedule: '00:00',
            timeOnSite: '00:00',
            totalBreakTime: '00:00',
            paidLeaves: 0,
            unPaidLeaves: 0,
            totalSickLeaveDays: 0,
            workingDays: 0,
            nonWorkingDays: 0,
            presentDays: 0,
            absent: 0,
            unscheduledWorkDays: 0,
            manuallyEditedDays: 0,
            bankedTime: '00:00',
            leaveDayWorkingHours: '00:00',
            loading: false,
            isRefreshing: false,
            singleDownloadLoad: false,
            fullDownloadLoad: false,
            report: [],
            locationIdOptions: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            firstCheckInTime: null,
            activityToDelete: null,
            isDeleting: false,
            totalScheduledBreak: '00:00',
            savedScrollTop: 0
        }
    },
    mounted() {
        this.initModalListeners();
    },
    methods: {
        getActivityTypeLabel,
        timeFormat,
        formatTo12Hour,
        formatDateTimeStandardWithTime,
        saveScrollTop() {
            const modalEl = document.getElementById('employee_report_modal');
            if (modalEl) {
                const modalBody = modalEl.querySelector('.modal-body');
                this.savedScrollTop = (modalBody ? modalBody.scrollTop : 0) || modalEl.scrollTop || 0;
            }
        },
        updateValues(userId, startDate, endDate) {
            this.userId = userId;
            
            const parseDateStr = (dateVal) => {
                if (!dateVal) return null;
                if (typeof dateVal === 'string' && dateVal.includes('-')) {
                    const parts = dateVal.split('-');
                    if (parts[0].length === 2 && parts[2].length === 4) {
                        return new Date(parts[2], parts[1] - 1, parts[0]);
                    }
                }
                const d = new Date(dateVal);
                return isNaN(d.getTime()) ? null : d;
            };

            if (startDate) {
                const parsed = parseDateStr(startDate);
                if (parsed) this.startDate = parsed;
            }
            if (endDate) {
                const parsed = parseDateStr(endDate);
                if (parsed) this.endDate = parsed;
            }
            this.getUserReport();
            this.getLocationIds();
        },
        getLocationName(id) {
            const location = this.locationIdOptions.find(item => item.id === id);
            return location ? location.text : '-';
        },
        toTimeString(minutes) {
            return minToTimeString(minutes);
        },
        dateToMonthName(date) {
            return formatDayDateMonthYear(date);
        },
        getDiffMinutes(start, end) {
            const startDate = new Date(start);
            const endDate = new Date(end);
            const diffMs = endDate - startDate;
            const totalMinutes = Math.floor(diffMs / 60000);
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            return `${hours.toString().padStart(2, '0')}hr : ${minutes.toString().padStart(2, '0')}min`;
        },
        onSearchClick() {
            this.getUserReport();
        },
        getUserReport(event) {
            if (!this.userId) return;
            const target = event?.currentTarget;
            if (target) {
                this.isRefreshing = true;
            } else {
                this.loading = true;
            }
            const formatDate = (dateObj) => {
                if (!dateObj) return null;
                const d = new Date(dateObj);
                if (isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            };

            const params = {
                start_date: formatDate(this.startDate),
                end_date: formatDate(this.endDate)
            }
            axios.get(`${VUE_APP_API_BASE_URL}/user/${this.userId}/report`, { params: params })
                .then((response) => {
                    if (response.data.status && response.data.data) {
                        const d = response.data.data;
                        this.userName = d.userName;
                        this.allowedBreak = minToTimeString(d.allowedBreak);
                        this.totalExtraBreak = d.totalExtraBreak || 0;
                        this.totalExpectedTimeOnSite = minToTimeString(d.expectedTimeOnSite);
                        this.totalTimeOnSiteAfterBreakDeduction = minToTimeString(d.totalTimeOnSiteAfterBreak);
                        this.totalTimeOnSiteAfterBreakSchedule = minToTimeString(d.totalTimeOnSiteAfterBreakSchedule);
                        this.totalTimeOnSiteIncludingBreakSchedule = minToTimeString(d.totalTimeOnSiteIncludingBreakSchedule);
                        this.timeOnSite = minToTimeString(d.timeOnSite);
                        this.totalBreakTime = minToTimeString(d.totalBreakTime);
                        this.paidLeaves = d.paidLeaves;
                        this.unPaidLeaves = d.unPaidLeaves;
                        this.totalSickLeaveDays = d.totalSickLeaveDays;
                        this.workingDays = d.workingDays;
                        this.nonWorkingDays = d.nonWorkingDays;
                        this.presentDays = d.presentDays;
                        this.absent = d.absent;
                        this.unscheduledWorkDays = d.unscheduledWorkDays ?? 0;
                        this.manuallyEditedDays = d.manuallyEditedDays ?? 0;
                        this.report = d.report || [];
                        this.bankedTime = minToTimeString(d.totalBankedTime);
                        this.leaveDayWorkingHours = minToTimeString(Math.round((d.leaveDayWorkingHours ?? 0) * 60));

                        // Calculate total scheduled break
                        let totalScheduledBreakMin = 0;
                        this.report.forEach(r => {
                            if (r.isPresent) {
                                totalScheduledBreakMin += (r.scheduledDeduction || 0);
                            }
                        });
                        this.totalScheduledBreak = minToTimeString(totalScheduledBreakMin);
                        if (target) {
                            this.$nextTick(() => {
                                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            });
                        }
                    } else {
                        const errMsg = response.data?.message ?? (response.data?.data?.message ?? 'Failed to get report');
                        this.$toast.error(errMsg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.isRefreshing = false;
                });
        },
        downloadUserReport() {
            this.singleDownloadLoad = true;
            const formatDate = (dateObj) => {
                if (!dateObj) return null;
                const d = new Date(dateObj);
                if (isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            };
            const details = { start_date: formatDate(this.startDate), end_date: formatDate(this.endDate) };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${this.userId}/report/download`, details, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => this.singleDownloadLoad = false);
        },
        downloadFullReport() {
            this.fullDownloadLoad = true;
            const formatDate = (dateObj) => {
                if (!dateObj) return null;
                const d = new Date(dateObj);
                if (isNaN(d.getTime())) return null;
                return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            };
            const details = { start_date: formatDate(this.startDate), end_date: formatDate(this.endDate) };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${this.userId}/full-report/download`, details, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => this.fullDownloadLoad = false);
        },
        async getLocationIds() {
            await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
                .then((response) => {
                    if (response.data.status) {
                        this.locationIdOptions = response.data.data.map(l => ({ ...l, text: l.name }));
                    }
                });
        },
        editScheduleClicked(record) {
            this.saveScrollTop();
            this.$refs.editSchedule.updateValues(record);
            Modal.getInstance(document.getElementById('employee_report_modal')).hide();
            const modal = new Modal(document.getElementById('edit_schedule_report'));
            modal.show();
        },
        editAttendanceClicked(record) {
            this.saveScrollTop();
            this.$refs.editAttendance.updateValues(record);
            Modal.getInstance(document.getElementById('employee_report_modal')).hide();
            const modal = new Modal(document.getElementById('edit_attendance_report'));
            modal.show();
        },
        editActivityClicked(record) {
            this.saveScrollTop();
            this.$refs.editActivity.updateValues(record);
            Modal.getInstance(document.getElementById('employee_report_modal')).hide();
            const modal = new Modal(document.getElementById('edit_activity_report'));
            modal.show();
        },
        openAddActivityModal(reportItem) {
            this.saveScrollTop();
            Modal.getInstance(document.getElementById('employee_report_modal')).hide();
            const modal = new Modal(document.getElementById('add_manual_activity_report'));
            modal.show();

            const modalComponent = this.$refs.addActivity;
            if (!modalComponent) return;

            let locationId = null;
            if (reportItem['schedule']?.['user_schedule_shifts'] && reportItem['schedule']['user_schedule_shifts'].length > 0) {
                locationId = reportItem['schedule']['user_schedule_shifts'][0].location_id;
            } else if (reportItem.activities && reportItem.activities.length > 0) {
                locationId = reportItem.activities[0].location_id;
            }

            modalComponent.prefillValues({
                employeeId: this.userId,
                date: reportItem['schedule']['date'] || null,
                time: '00:00:00',
                locationId
            });
        },
        deleteActivityClicked(activity) {
            this.saveScrollTop();
            this.activityToDelete = activity;
            Modal.getInstance(document.getElementById('employee_report_modal')).hide();
            const modal = new Modal(document.getElementById('delete_activity_modal_report'));
            modal.show();
        },
        async onDeleteConfirmed() {
            if (!this.activityToDelete) return;
            await this.deleteActivity(this.activityToDelete.id);
            const modal = Modal.getInstance(document.getElementById('delete_activity_modal_report'));
            if (modal) modal.hide();
            this.activityToDelete = null;
        },
        async deleteActivity(activityId) {
            this.isDeleting = true;
            try {
                const response = await axios.post(`${VUE_APP_API_BASE_URL}/activity/delete`, { id: activityId });
                if (response.data.status) {
                    this.$toast.success('Activity deleted successfully');
                    this.getUserReport();
                }
            } finally {
                this.isDeleting = false;
            }
        },
        initModalListeners() {
            const subModals = [
                'edit_attendance_report',
                'edit_schedule_report',
                'edit_activity_report',
                'add_manual_activity_report',
                'delete_activity_modal_report'
            ];

            subModals.forEach(id => {
                const element = document.getElementById(id);
                if (element) {
                    element.addEventListener('hidden.bs.modal', () => {
                        const mainModal = Modal.getOrCreateInstance(document.getElementById('employee_report_modal'));
                        mainModal.show();
                    });
                }
            });

            const mainModalEl = document.getElementById('employee_report_modal');
            if (mainModalEl) {
                let scrollInterval;

                mainModalEl.addEventListener('show.bs.modal', () => {
                    if (this.savedScrollTop > 0) {
                        scrollInterval = setInterval(() => {
                            const modalBody = mainModalEl.querySelector('.modal-body');
                            if (modalBody) modalBody.scrollTop = this.savedScrollTop;
                            mainModalEl.scrollTop = this.savedScrollTop;
                        }, 10);
                    }
                });

                mainModalEl.addEventListener('shown.bs.modal', () => {
                    if (scrollInterval) {
                        clearInterval(scrollInterval);
                    }
                    if (this.savedScrollTop > 0) {
                        const modalBody = mainModalEl.querySelector('.modal-body');
                        if (modalBody) modalBody.scrollTop = this.savedScrollTop;
                        mainModalEl.scrollTop = this.savedScrollTop;
                        
                        setTimeout(() => { 
                            if (modalBody) modalBody.scrollTop = this.savedScrollTop;
                            mainModalEl.scrollTop = this.savedScrollTop; 
                            this.savedScrollTop = 0;
                        }, 50);
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
/* Add premium box shadow to sub-modals to separate them from the fullscreen background */
:deep(.modal-content) {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), 0 5px 15px rgba(0, 0, 0, 0.15) !important;
    border: none !important;
}

.custom-modal .modal-content .modal-header {
    border: 1px inset rgb(58, 58, 58);
    justify-content: space-between;
    padding: 15px 30px;
    background: #099bf8;
}
.modal-title {
    color: #ffffff;
}
.btn-close {
    background-color: transparent !important;
    font-size: 25px;
    color: white;
}
.icon-circle {
    display: flex;
    background-color: #f7f7f7;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    width: 30px;
    aspect-ratio: 1;
}

.icon-circle-2 {
    display: flex;
    background-color: transparent;
    border: 1px solid ;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 5px 10px;
}
.content {
    padding: 30px;
}
/* Ensure sub-modals stack above the fullscreen modal (z-index 1055) */
.modal-fullscreen ~ .modal,
.modal-body .modal {
    z-index: 1070 !important;
}

tbody, thead {
    font-size: 16px;
}
</style>
